module.exports = __webpack_public_path__ + "static/media/Mail.3cceb268.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/referral/Mail.png
// module id = 1381
// module chunks = 0